import React, { useState } from "react";
import { Popover } from "antd";
import { Localize } from "components/service";


const StaffManagementSubcontractorsField = ({ count, subcontractors = [] }) => {
    const [ visible, setVisible ] = useState(false);
    const subcontractorsLabel = Localize({
        children: "STAFF_MANAGEMENT.Text_Subcontractors",
    }).props.children;

    return count ?
        <Popover
            visible={ visible }
            onVisibleChange={ setVisible }
            overlayClassName="staff-subcontractors-popover"
            placement="bottomLeft"
            trigger="click"
            content={
                <div className="d-flex flex-column staff-subcontractors-popover__content">
                    <strong>
                        { count } { subcontractorsLabel }
                    </strong>
                    { subcontractors.map((subcontractor) => (
                        <span key={ subcontractor.id }>{ subcontractor.title }</span>
                    )) }
                </div>
            }>
            <button
                aria-expanded={ visible }
                aria-label={ `${ count } ${ subcontractorsLabel }` }
                className="btn-text-link staff-management-list__subcontractors"
                type="button">
                <span>{ count }</span>
            </button>
        </Popover> :
        <span>&mdash;</span>;
};

export default StaffManagementSubcontractorsField;
